import styled from "@emotion/styled"
import { PButton } from "@porsche-design-system/components-react"
import type { ActionItemWithLinks, LocalizedLink } from "@slfinrtl/ui-bff-routes"
import { useCallback, useState } from "react"
import { Tooltip } from "src/components"

interface OpenListingButtonLinkProps {
	onOpenListingClick: (links: LocalizedLink[]) => Promise<void>
	openListing: ActionItemWithLinks
}

export const OpenListingButtonLink = (props: OpenListingButtonLinkProps) => {
	const { onOpenListingClick, openListing: openListingAction } = props
	const { disabledHint } = openListingAction

	const [isLoading, setIsLoading] = useState(false)

	const hasListing = openListingAction.links && openListingAction.links.length > 0

	const handleClick = useCallback(() => {
		setIsLoading(true)
		onOpenListingClick(openListingAction.links).finally(() => setIsLoading(false))
	}, [onOpenListingClick, openListingAction.links])

	return hasListing && disabledHint === undefined ? (
		<PButton
			type="button"
			icon="external"
			hideLabel={{ base: true, m: false }}
			loading={isLoading}
			onClick={handleClick}
		>
			{openListingAction.label}
		</PButton>
	) : (
		<StyledTooltip placement="left" content={disabledHint}>
			<PButton type="button" icon="external" disabled hideLabel={{ base: true, m: false }}>
				{openListingAction.label}
			</PButton>
		</StyledTooltip>
	)
}

const StyledTooltip = styled(Tooltip)`
	display: inline-flex;
	cursor: not-allowed;
`
